import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [meta, setMeta] = useState(null);

  async function loadMeta() {
    try {
      const { data } = await api.get("/meta");
      setMeta(data);
    } catch (e) { /* ignore */ }
  }

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("mj_token");
      if (!token) { setUser(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
        loadMeta();
      } catch {
        localStorage.removeItem("mj_token");
        setUser(false);
      }
    })();
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mj_token", data.token);
    setUser(data.user);
    loadMeta();
    return data.user;
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("mj_token");
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, meta, login, logout, loadMeta }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiErrorDetail };
